export default "/dist/files/rubrique_actualites.91305a0e80584b7597545e8238bfb8b5.svg";